import React, { useState } from 'react'
import styled from 'styled-components'
import { Modal } from 'reactstrap'
import axios from 'axios'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'

import { Loading } from '../loading'
import { CloseIcon } from '../icons'
import { Button } from '../buttons'
import { BASE_URL, FONTS } from '../../constants'

export const CropImageModal = React.memo(props => {
  const [isFetching, setIsFetching] = useState(false)

  const { src, userID, isOpen, handleClose, handleUpload } = props

  const rotateImage = (degree) => {
    if (typeof this.cropper === 'undefined' || this.cropper.getCroppedCanvas() === null) {
      return
    }
    this.cropper.rotate(degree)
  }

  const cropImage = () => {
    if (typeof this.cropper.getCroppedCanvas() === 'undefined' || this.cropper.getCroppedCanvas() === null) {
      return
    }
    setIsFetching({ isFetching: true })
    this.cropper.getCroppedCanvas().toBlob((blob) => {
      const data = new FormData()

      data.set('user_id', userID)

      const image = new Image()
      image.onload = function () {
        // Resize image
        const canvas = document.createElement('canvas')
        canvas.width = 600
        canvas.height = 600
        canvas.getContext('2d').drawImage(image, 0, 0, 600, 600)

        canvas.toBlob((innerBlob) => {
          data.set('image', innerBlob)

          canvas.width = 128
          canvas.height = 128
          canvas.getContext('2d').drawImage(image, 0, 0, 128, 128)
          canvas.toBlob((innerBlob2) => {
            data.set('image_thumbnail', innerBlob2)

            axios({
              method: 'post',
              url: `${BASE_URL}/upload/user-profile-image`,
              headers: {
                'authorization': `bearer ${localStorage.getItem('access_token')}`,
              },
              data,
            }).then((resp) => {
              if (resp.status === 200) {
                handleUpload(resp)
                setIsFetching({ isFetching: false })
              }
            })
          })
        })
      }
      image.src = this.cropper.getCroppedCanvas().toDataURL('image/jpeg')
    })
  }

  return (
    <Modal isOpen={ isOpen } toggle={ handleClose }>
      <Loading isLoading={ isFetching } />
      <ModalHeader>
        <Header>Crop Image</Header>
        <CloseIcon onClick={ handleClose } />
      </ModalHeader>
      <ModalBody>
        <Cropper
          style={ { height: 400, width: '100%' } }
          preview=".img-preview"
          guides={ false }
          aspectRatio={ 1 }
          src={ src }
          ref={ cropper => { this.cropper = cropper } }
          setDragMode={ 'crop' }
          movable={ false }
          center={ true }
        />
      </ModalBody>
      <Footer>
        <ButtonGroup>
          <Button
            theme='#428BCA'
            width='80px'
            height='26px'
            radius='4px 0 0 4px'
            onClick={ () => rotateImage(90) }
          >
            Rotate 90
          </Button>
          <Button
            theme='#428BCA'
            width='80px'
            height='26px'
            radius='0 4px 4px 0'
            onClick={ () => rotateImage(-90) }
          >
            Rotate -90
          </Button>
        </ButtonGroup>
        <Button
          theme='#6c757d'
          width='70px'
          height='26px'
          onClick={ handleClose }
        >
          Cancel
        </Button>
        <Button
          theme='#428BCA'
          width='70px'
          height='26px'
          onClick={ cropImage }
        >
          Crop
        </Button>{' '}
      </Footer>
    </Modal>
  )
})

const Header = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: #333333;
`

const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px 0 16px;
`

const ModalBody = styled.div`
  padding: 24px 16px;
`

const Footer = styled.div`
  height: 42px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #F9F9F9;
  padding: 0 16px;

  > * {
    margin-left: 12px;
  }
`

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/modal/crop-image-modal.js